const trimName = (name) => {
  if (name.length > 15) return `${name.substr(0, 15)}...`;
  return name;
};

export const getNameInitials = (string = '') => {
  const name = string.trim();
  const wordArray = name.split(' ');
  if (wordArray.length < 2) {
    return wordArray[0].substr(0, 2).toUpperCase();
  }

  return `${wordArray[0][0].toUpperCase()}${wordArray[
    wordArray.length - 1
  ][0].toUpperCase()}`;
};

export default trimName;



// WEBPACK FOOTER //
// ./src/utils/trimName.js